module.exports = __webpack_public_path__ + "img/crate.da499b85.gif";